export function getFormUrl(formName: string): string {
  const urls: Record<string, string> = {
    'Newsletter Signup': 'https://readdy.ai/api/form/d8vu15us51g94qljs2ug',
  };
  return urls[formName] || '';
}